import WordLookup from "../components/WordLookup";

export default function WordLookupPage() {
  return <WordLookup />;
}